import React, { useEffect, useRef, useState } from "react";
import { Animated, ImageBackground, Platform } from "react-native";
import { isPortrait, SCREEN_WIDTH } from "../../../utils/common";
import {
  BtnSidebarClosePng,
  SidebarBackgroundPng,
  SidebarLeftLightPng,
  VipBadgeFramePng,
} from "../../../assets";
import { AvatarFrameWithGradient, Overlay } from "../index";
import { AvatarGradientColor } from "../../../../typings/types";
import { useDevice } from "../../../utils/hooks/useDevice";

import { Image, ScrollView, Text, TouchableOpacity, View } from "react-native";
import {
  SidebarContentInvites,
  SidebarContentBonus,
  SidebarContentExit,
  SidebarContentGameRules,
  SidebarContentHelp,
  SidebarContentPersonalData,
  SidebarContentRankings,
  SidebarContentSettings,
  SidebarContentShop,
  SidebarContentTutorial,
} from "../../../assets/sidebar/content";
import { useTranslation } from "react-i18next";
import { useNavigation } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { RootStackParamList } from "../../navigator";
import { useSelector } from "react-redux";
import { selectIsLogged } from "../../../store/auth/authReducer";
import LS from "../../../utils/localStorageUtils";
import { useDispatch } from "react-redux";
import { logout } from "../../../store/auth/authActions";
import { analyticsEvents } from "../../../services/firebase/analytics-events.service";
import { deltaDNAService } from "../../../services/deltaDNA/deltadna.service";
import { RootState } from "../../../store";

type Nav = NativeStackNavigationProp<RootStackParamList>;

const appPackage = require("../../../../package.json") as { version?: string };
const APP_VERSION = appPackage.version ?? "";

type SidebarButton = {
  label: string;
  icon: any;
  onPress: () => void;
};

const Sidebar = ({
  onClose,

  onOpenBonusGamesModal,
}: {
  onClose: () => void;

  onOpenBonusGamesModal: () => void;
}) => {
  const { isMobile, isMd, isSm } = useDevice();
  const player = useSelector((s: RootState) => s.auth.user);

  const SIDEBAR_WIDTH_STYLE = isMobile
    ? ("60%" as const)
    : isSm
      ? ("60%" as const)
      : isMd
        ? ("50%" as const)
        : ("23%" as const);

  const SIDEBAR_WIDTH_ANIM =
    isMobile || isMd ? SCREEN_WIDTH * 0.6 : SCREEN_WIDTH * 0.5;

  const translateX = useRef(new Animated.Value(SIDEBAR_WIDTH_ANIM)).current;

  useEffect(() => {
    Animated.timing(translateX, {
      toValue: 0,
      duration: 580,
      useNativeDriver: true,
    }).start();
  }, []);

  const closeAnimated = () => {
    Animated.timing(translateX, {
      toValue: SIDEBAR_WIDTH_ANIM,
      duration: 550,
      useNativeDriver: true,
    }).start(({ finished }) => {
      if (finished) onClose();
    });
  };

  const { t } = useTranslation();

  const { navigate } = useNavigation<Nav>();
  const isLogged = useSelector(selectIsLogged);

  const dispatch = useDispatch();
  const onAuthPress = () => {
    if (isLogged) {
      console.log("beforeee exit");
      // LS.remove("access_token");
      // LS.remove("auth_user");
      // dispatch(logout());
      // navigate("Main");
      analyticsEvents.trackUserLogout();
      deltaDNAService.reset();
      exit();
    } else {
      if (Platform.OS === "web") {
        navigate("Login");
      } else {
        navigate("AuthGate");
      }
    }
  };
  const exit = () => {
    LS.remove("access_token");
    LS.remove("refresh_token");
    LS.remove("auth_user");
    dispatch(logout());
    navigate("Main");
  };
  const buttons: SidebarButton[] = [
    // {
    //   label: t("sidebar.register"),
    //   icon: SidebarContentInvites,
    //   onPress: () => navigate("Register"),
    // },
    !isLogged && {
      label: t("T_SITE_LOGIN_TITLE"),
      icon: SidebarContentRankings,
      onPress: () => {
        onClose();
        onAuthPress();
      },
    },
    {
      label: t("T_SITE_MENU_RANKING"),
      icon: SidebarContentRankings,
      onPress: () => navigate("Ranking"),
    },
    {
      label: t("T_SITE_MENU_INVITES"),
      icon: SidebarContentInvites,
      onPress: () => navigate("Invites"),
    },
    {
      label: t("T_SITE_MENU_BONUSES"),
      icon: SidebarContentBonus,
      onPress: onOpenBonusGamesModal,
    },
    {
      label: t("T_SITE_MENU_SHOP"),
      icon: SidebarContentShop,
      onPress: () => navigate("BuyPackages", { activeTab: "chips" }),
    },
    {
      label: t("T_SITE_MENU_SETTINGS"),
      icon: SidebarContentSettings,

      onPress: () => {
        onClose();
        navigate("Settings");
      },
    },
    // {
    //   label: t("T_SITE_MODAL_INVITATION_SEARCH"),
    //   icon: SidebarContentHelp,
    //   onPress: () => {
    //     onClose();
    //     navigate("Search");
    //   },
    // },

    // {
    //   label: "Home",
    //   icon: SidebarContentRankings,
    //   onPress: () => navigate("Main"),
    // },

    {
      label: t("T_SITE_MENU_PERSONAL_DATA"),
      icon: SidebarContentPersonalData,
      onPress: () => navigate("PersonalData"),
    },
    {
      label: t("T_SITE_MENU_TUTORIAL"),
      icon: SidebarContentTutorial,
      onPress: () => {
        if (isLogged) {
          navigate("Tutorial", { isTutorial: true });
        } else {
          navigate("Login");
        }
      },
    },
    {
      label: t("T_SITE_MENU_RULES"),
      icon: SidebarContentGameRules,
      onPress: () => navigate("GameRules"),
    },
    {
      label: t("T_SITE_MENU_CONTACTS"),
      icon: SidebarContentHelp,
      onPress: () => navigate("Help"),
    },
    isLogged && {
      label: t("T_SITE_MENU_LOGOUT"),
      icon: SidebarContentRankings,
      onPress: () => {
        onClose();
        onAuthPress();
      },
    },
  ].filter(Boolean) as SidebarButton[];
  const renderButtons = () => {
    // if (isMobile) {
    return buttons.map(({ label, icon, onPress }) => (
      <TouchableOpacity
        key={label}
        onPress={onPress}
        style={{
          flexDirection: "row",
          alignItems: "center",
          marginBottom: 0,
        }}
      >
        <Image
          source={icon}
          style={{ width: 45, height: 45, marginRight: 10 }}
        />
        <Text style={{ fontSize: 14, color: "white" }}>{label}</Text>
      </TouchableOpacity>
    ));
    // }

    // Two-column layout for non-mobile
    // const rows = [] as JSX.Element[];
    // for (let i = 0; i < buttons.length; i += 2) {
    //   rows.push(
    //     <View
    //       key={`row-${i}`}
    //       style={{
    //         flexDirection: "row",
    //         justifyContent: "space-between",
    //         marginBottom: 12,
    //       }}
    //     >
    //       {[buttons[i], buttons[i + 1]].map(
    //         (btn, idx) =>
    //           btn && (
    //             <TouchableOpacity
    //               key={idx}
    //               onPress={btn.onPress}
    //               style={{
    //                 flexDirection: "row",
    //                 alignItems: "center",
    //                 flex: 1,
    //                 marginRight: idx === 0 ? 20 : 0,
    //               }}
    //             >
    //               <Image
    //                 source={btn.icon}
    //                 style={{ width: 52, height: 52, marginRight: 10 }}
    //               />
    //               <Text style={{ fontSize: 14, color: "white" }}>
    //                 {btn.label}
    //               </Text>
    //             </TouchableOpacity>
    //           )
    //       )}
    //     </View>
    //   );
    // }
    // return rows;
  };

  return (
    <Overlay onClose={closeAnimated}>
      <Animated.View
        style={{
          width: SIDEBAR_WIDTH_STYLE,
          transform: [{ translateX }],
          position: "absolute",
          top: 0,
          right: 0,
          height: "100%",
          zIndex: 1000,
          elevation: 10,
        }}
        // style={{
        //   position: "absolute",
        //   top: 0,
        //   right: 0,
        //   width: SIDEBAR_WIDTH.style,
        //   height: "100%",
        //   zIndex: 100,
        //   elevation: 4,
        //   transform: [{ translateX }],
        // }}
      >
        <View
          style={{
            width: "100%",
            height: "100%",
          }}
        >
          <ImageBackground
            source={SidebarBackgroundPng}
            resizeMode="cover"
            style={{
              width: "100%",
              height: "100%",
            }}
          >
            <TouchableOpacity
              onPress={closeAnimated}
              hitSlop={{ top: 20, bottom: 20, left: 20, right: 20 }}
              activeOpacity={0.7}
              style={{
                zIndex: 999,
                position: "absolute",
                width: 25,
                height: 25,
                top: 22,
                right: 22,
                elevation: 10,
              }}
            >
              <Image
                source={BtnSidebarClosePng}
                style={{
                  width: "100%",
                  height: "100%",
                }}
              />
            </TouchableOpacity>

            {/*<Image*/}
            {/*  source={SidebarTopLightPng}*/}
            {/*  style={{*/}
            {/*    position: "absolute",*/}
            {/*    width: '100%',*/}
            {/*    height: 100,*/}
            {/*    left: -20,*/}
            {/*  }}*/}
            {/*/>*/}

            <View style={{ alignItems: "center" }}>
              <View style={{ position: "relative" }}>
                <AvatarFrameWithGradient
                  gradientColor={AvatarGradientColor.Blue}
                  sizeMultiplier={1.6}
                  showUsernameFrame={true}
                />
                {player?.isVip && (
                  <Image
                    source={VipBadgeFramePng}
                    style={{
                      position: "absolute",
                      top: 64,
                      right: 14,
                      width: 35,
                      height: 35,
                      zIndex: 22,
                    }}
                  />
                )}
              </View>
            </View>
            <ScrollView contentContainerStyle={{ padding: 20 }}>
              {renderButtons()}
            </ScrollView>
            <View
              style={{
                position: "absolute",
                bottom: 16,
                left: 0,
                right: 0,
                alignItems: "center",
              }}
            >
              <Text
                style={{
                  color: "#ffffff",
                  fontSize: 12,
                  opacity: 0.8,
                }}
              >
                v{APP_VERSION}
              </Text>
            </View>
          </ImageBackground>

          <Image
            source={SidebarLeftLightPng}
            style={{
              position: "absolute",
              width: 40,
              height: "100%",
              left: -20,
            }}
          />
        </View>
      </Animated.View>
    </Overlay>
  );
};

export default Sidebar;

//  return (
//     <View
//       style={{
//         position: "absolute",
//         overflow: "hidden",
//         top: 0,
//         left: 0,
//         width: "100%",
//         height: "100%",
//         zIndex: 99,
//       }}
//     >
//       <TouchableWithoutFeedback onPress={() => setIsSidebarOpen(false)}>
//         <View style={styles.overlay} />
//       </TouchableWithoutFeedback>
//
//       <Animated.View style={[styles.sidebar, { transform: [{ translateX }] }]}>
//         <View
//           style={{
//             width: "100%",
//             height: "100%",
//           }}
//         >
//           <ImageBackground
//             source={SidebarBackgroundPng}
//             resizeMode="stretch"
//             style={{
//               width: "100%",
//               height: "100%",
//             }}
//           >
//             <TouchableOpacity
//               onPress={() => setIsSidebarOpen(false)}
//               style={{
//                 zIndex: 1,
//                 position: "absolute",
//                 width: 22,
//                 height: 22,
//                 top: 22,
//                 right: 22,
//               }}
//             >
//               <Image
//                 source={BtnSidebarClosePng}
//                 style={{
//                   width: "100%",
//                   height: "100%",
//                 }}
//               />
//             </TouchableOpacity>
//
//             {/*<Image*/}
//             {/*  source={SidebarTopLightPng}*/}
//             {/*  style={{*/}
//             {/*    position: "absolute",*/}
//             {/*    width: '100%',*/}
//             {/*    height: 100,*/}
//             {/*    left: -20,*/}
//             {/*  }}*/}
//             {/*/>*/}
//
//             <View style={{ alignItems: "center", marginTop: 30 }}>
//               <AvatarFrame sizeMultiplier={1.6} showUsernameFrame={true} />
//             </View>
//
//             <SidebarContent />
//           </ImageBackground>
//
//           <Image
//             source={SidebarLeftLightPng}
//             style={{
//               position: "absolute",
//               width: 40,
//               height: "100%",
//               left: -20,
//             }}
//           />
//         </View>
//       </Animated.View>
//     </View>
//   );
